import React from 'react';
import { formatMoney } from 'src/utils';

interface IProps {
  text: string;
  className?: string;
  data?: string | number;
}

const Description: React.FC<IProps> = ({ text, className, data }) => {
  const totalAmt = formatMoney(data ?? '', 'Rs');
  return (
    <h6
      className={`text-base mb-4 text-text-black capitalize flex justify-between items-center ${className} `}
    >
      <p>{text}</p>
      <p>{totalAmt}</p>
    </h6>
  );
};

export default React.memo(Description);
